@if (loader) {
  <div class="loader-overlay"></div>
}
@if (loader) {
  <span id="loading"></span>
}

<nav class="wb-top">
  <div class="wb-contain wb-page-login">
    @if (form.config.logo) {
      <div class="wb-logo wb-page-login wb-logo-centered">
        <img src="{{form.config.logo}}" alt="logo">
      </div>
    }
    @if (!form.config.logo) {
      <h3 class="wb-logo wb-logotext wb-page-login wb-formtitle">{{form.name}}</h3>
    }
    <div class="wb-main">
      <h3 class="wb-formtitle">{{'form_title' | translate | ucFirst}}</h3>
      <div class="wb-steps">

      </div>
    </div>
  </div>
</nav>

<form [formGroup]="formGroup" class="wb-form-container" autocomplete="off">
  <!-- First field is to throw off browsers from using autocomplete -->
  <input autocomplete="off" name="hidden" type="text" style="display:none;">

  <h3>
    {{'reset_password_title' | translate | ucFirst}}
  </h3>
  <div>
    {{'reset_password_subtitle' | translate | ucFirst}}
  </div>

  <div class="field">
    <span class="wb-summary-name">
      {{'email' | translate | ucFirst}} <span
    class="wb-field-wrapper-required">*</span>
    @if (false) {
      <span class="wb-help" (click)="toggleHelpModal(field.label, field.helpText)"><app-svg-icon
      [icon]="faInfoCircle"></app-svg-icon></span>
    }
  </span>
  <ng-container>
    <input formControlName="email" type="text" id="email" [ngClass]="loginError ? 'error' : ''"
      placeholder="{{'email' | ucFirst}}">
    </ng-container>
  </div>
  @if (loginError) {
    <div class="errorMsg">
      {{loginError | translate | ucFirst}}
    </div>
  }
  <nav class="wb-form wb-page-login" #formNavigation>
    <div class="wb-container">
      <button class="wb-next" (click)="requestNewPassword()">
        {{'request_password_reset' | translate | ucFirst}}
      </button>
      <button class="wb-previous" routerLink="../login">
        {{'back' | translate | ucFirst}}
      </button>
    </div>
  </nav>
</form>
